import { h, Component } from 'preact';
import { Link } from 'preact-router/match';
import { route } from 'preact-router';
import style from './style';
import logo from '../../assets/images/fhird-logo-large.png';
import hamburger from '../../assets/images/hamburger.png';

export default class Header extends Component {
	state = {
		toggled: false
	};

	toggle = () => {
		this.setState({ toggled: !this.state.toggled });
	};

	navigate = destination => {
		this.toggle();
		route(destination);
	};

	contact = () => {
		window.location = 'mailto:hello@fhird.com';
	};

	componentDidMount = () => {
		window.scrollTo(0, 0);
	};

	render = () => (
		<header class={style.header}>
			<div class="row">
				<div class="hidden-lg">
					<Link href="/">
						<img class={style.logosm} src={logo} />
					</Link>
					<img class={style.hamburger} src={hamburger} onClick={this.toggle} />
					{this.state.toggled ? (
						<div class={style.menu}>
							<ul>
								<li onClick={() => this.navigate('/')}>what we do</li>
								<li onClick={() => this.navigate('/one-api')}>one api</li>
								<li onClick={() => this.navigate('/join-our-team')}>
									join our team
								</li>
								<li onClick={this.contact}>contact</li>
							</ul>
						</div>
					) : null}
				</div>
				<div class="hidden-sm">
					<Link href="/">
						<img class={style.logo} src={logo} />
					</Link>
					<nav>
						<Link activeClassName={style.active} href="/">
							what we do
						</Link>
						<Link activeClassName={style.active} href="/one-api">
							one api
						</Link>
						<Link activeClassName={style.active} href="/join-our-team">
							join our team
						</Link>
						<a href="mailto:hello@fhird.com">contact</a>
					</nav>
				</div>
			</div>
		</header>
	);
}



// WEBPACK FOOTER //
// ./components/header/index.js